export const keyMap = {
    "name": "n",
    "shortName": "sn",
    "nickName": "nn",
    "abbreviation": "a",
    "league": "l",
    "city": "c",
    "metadata": "m",
    "type": "t", 
    "value": "v",
    "attributes": "at",
    "colors": "cl",
    "primary": "p",
    "secondary": "s",
    "images": "i", 
    "jerseyType": "j",
    "cid": "cid"
}

export const reverseKeyMap = Object.fromEntries(Object.entries(keyMap).map(entry => entry.reverse()));

export function replaceKeys(obj, map) {
    return Object.entries(obj).reduce((acc, [key, value])=>{
      if (key === "alternateNames") return acc;
      if (typeof value === "object") {
        acc[map[key]] = replaceKeys(value, map);
      } else {
        acc[map[key]] = value;
      }
      return acc;
    },{})
}